import licensesModalStyle from '../css/licenses-modal.module.css';
import ResultModalContainer from 'components/ResultModalContainer';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { timeFormat } from "const/nuclias/dateFormat";
import { messageKeyPrefix } from "utils/message.util";

import { jsonToCsv } from "utils/downloadFile.util";

import { isNil } from "lodash";
import dayjs from "dayjs";

const ResultModal = ({
  results,
  resultModalStatus,
  setResultModalStatus
}) => {
  const { t } = useTranslation();
  const [foramtList, setForamtList] = useState([]);
  const headers = [t('ec53a8c4f0'), t('5d5c4ad5db'), t('3ec365dd53')];

  const foramt = () => {
    const list = [];
    for (const item of results) {
      if (Object.keys(item).length > 0) {
        const isSuccess = isNil(item.error) ? true : false;
        list.push({
          requriedStatusType: isSuccess ? 'success' : 'error',
          status: isSuccess ? t('30ae8fff88') : t('d7c8c85bf7'),
          licenseKey: item.licenseKey || item.license,
          details: isSuccess ? t(`${messageKeyPrefix.s.c}1001`) : t(`${messageKeyPrefix.e.s}${item.error.code}`) //1260
        });
      }
    }
    setForamtList((foramtList) => (list));
  };

  const downloadResult = () => {
    let fields = ['status', 'licenseKey', 'details'];
    const fileName = `${'Import-License-Result'}_${dayjs().format(timeFormat.csvDownloadFormat)}.csv`;
    jsonToCsv(fileName, headers, fields, foramtList);
  };

  useEffect(() => {
    foramt();
  }, [results]);

  return (
    <div className={licensesModalStyle['result-modal']}>
      {
        <ResultModalContainer
          thList={headers}
          results={foramtList}
          onDownload={() => downloadResult()}
          openModal={resultModalStatus}
          closeModal={() => setResultModalStatus(false)}
        />
      }
    </div>
  );
};

export default ResultModal;